export enum ComponentName {
    CHANNEL_LIVE = "ChannelLive",
}
